import { redirect } from 'react-router-dom';

export const transactionsRoute = {
  path: 'transactions',
  children: [
    {
      path: '',
      loader: () => redirect('store'),
    },
    {
      path: 'store',
      lazy: () => import('./store'),
    },
    {
      path: 'inventory',
      lazy: () => import('./inventory'),
    },
  ],
};
